export default __webpack_public_path__ + "static/biocultus-e633006d1ceeaf144d9b7741ee183191.jpg";